import { format, isSameMonth, isToday } from "date-fns";
import { STATUS_META, isOverdue } from "../ui-bits";
import { cn } from "../../lib/utils";

const MAX_LANES = 3;
const LANE_H = 22;
const HEADER_H = 26;

function dayNumberClass(day, inMonth) {
  if (isToday(day)) return "h-5 w-5 flex items-center justify-center rounded-full bg-[#E31E24] text-white font-bold";
  if (inMonth) return "text-foreground";
  return "text-muted-foreground";
}

function barRadius(b) {
  return {
    borderTopLeftRadius: b.isStart ? 4 : 0,
    borderBottomLeftRadius: b.isStart ? 4 : 0,
    borderTopRightRadius: b.isEnd ? 4 : 0,
    borderBottomRightRadius: b.isEnd ? 4 : 0,
  };
}

export default function CalendarWeekRow({ week, weekKey, bars, hiddenCount, laneCount, month, onOpenTask, onAddTask }) {
  const bodyH = Math.max(1, Math.min(laneCount, MAX_LANES) + (hiddenCount > 0 ? 1 : 0)) * LANE_H;

  return (
    <div className="relative border-b border-border last:border-b-0">
      <div className="grid grid-cols-7" style={{ height: HEADER_H + bodyH + 4 }}>
        {week.map((day) => {
          const key = format(day, "yyyy-MM-dd");
          const inMonth = isSameMonth(day, month);
          return (
            <div key={key} data-testid={`calendar-day-${key}`}
              className={cn("border-r border-border last:border-r-0 p-1 group relative", !inMonth && "bg-muted/30", isToday(day) && "bg-[#E31E24]/5")}>
              <div className="flex items-center justify-between">
                <span className={cn("text-xs px-1", dayNumberClass(day, inMonth))}>{format(day, "d")}</span>
                <button data-testid={`calendar-add-${key}`} onClick={() => onAddTask(key)}
                  className="h-4 w-4 hidden group-hover:flex items-center justify-center rounded text-muted-foreground hover:text-[#E31E24] text-xs font-bold">+</button>
              </div>
            </div>
          );
        })}
      </div>

      <div className="absolute left-0 right-0 pointer-events-none" style={{ top: HEADER_H }}>
        {bars.map((b) => (
          <button key={`${b.task.id}-${weekKey}`} data-testid={`calendar-bar-${b.task.id}`}
            onClick={() => onOpenTask(b.task)}
            title={`${b.task.title} (${b.task._start} → ${b.task._end})`}
            className={cn("absolute h-5 px-1.5 text-[11px] leading-5 text-white truncate text-left pointer-events-auto hover:opacity-85 transition-opacity", isOverdue(b.task) && "ring-2 ring-[#E31E24]")}
            style={{
              left: `calc(${(b.startIdx / 7) * 100}% + 2px)`,
              width: `calc(${(b.span / 7) * 100}% - 4px)`,
              top: b.lane * LANE_H,
              backgroundColor: STATUS_META[b.task.status]?.color,
              ...barRadius(b),
            }}>
            {(b.isStart || b.startIdx === 0) ? b.task.title : ""}
          </button>
        ))}
        {hiddenCount > 0 && (
          <div className="absolute text-[10px] text-muted-foreground px-2" style={{ top: MAX_LANES * LANE_H }} data-testid={`calendar-more-${weekKey}`}>
            +{hiddenCount} more
          </div>
        )}
      </div>
    </div>
  );
}
